<template>
  <div>
    <!-- Chargement -->
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    <!-- TABS -->
    <v-tabs v-else icons-and-text centered slider-color="secondary" color="primary" dark>
        <v-tab href="#tab-1" @click.native="hideRenderPush">
          Description
          <v-icon>description</v-icon>
        </v-tab>
        <v-tab href="#tab-2" @click.native="hideRenderPush">
          {{ $t('behaviour') }}
          <v-icon>pages</v-icon>
        </v-tab>
        <v-tab href="#tab-3" @click.native="renderPush">
          {{ $t('preview') }}
          <v-icon>movie_filter</v-icon>
        </v-tab>
      <!-- TAB 1 -->
      <v-tab-item id='tab-1' key='1'>
        <v-card>
          <v-card-text>
            <v-subheader>Push</v-subheader>
            <!-- NOM -->
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field v-model="push.name" :label="$t('name') | cap"></v-text-field>
              </v-flex>
            </v-layout>
            <!-- TYPE -->
            <v-layout row wrap>
              <v-flex xs12>
                <v-select :items="push_type" v-model="push.style" :label="$t('type') | cap" auto></v-select>
              </v-flex>
            </v-layout>

            <v-subheader>Pop-up</v-subheader>
            <div v-show="push.style == 'classic'">
              <!-- Titre -->
              <v-layout row wrap>
                <!-- Titre de la 'Popup' -->
                <v-flex xs12>
                  <v-text-field v-model="push.title" :label="$t('title') | cap"></v-text-field>
                </v-flex>
              </v-layout>
              <!-- Contenu -->
              <v-layout row wrap>
                <!-- Contenu de la 'Popup' -->
                <v-flex xs12>
                  <v-text-field v-model="push.content" :label="$t('message') | cap"></v-text-field>
                </v-flex>
              </v-layout>
              <!-- Photo -->
              <v-layout row wrap>
                <!-- Illustration de la 'Popup' -->
                <v-flex xs12>
                  <v-select :items="imgpush" v-model="push.img" :label="$t('whichImgDisplay')" auto></v-select>
                </v-flex>
              </v-layout>
            </div>
            <div v-show="push.style == 'picture' || push.style == 'html'">
              <!-- OVERLAY -->
              <v-layout row wrap>
                <!-- Arrière-plan au push -->
                <v-flex xs12>
                  <v-switch
                    v-model="push.overlay"
                    :label="'Overlay ' + $t('enabled') + '? (fond opaque)'"
                    color="primary"
                  ></v-switch>
                </v-flex>
              </v-layout>
              <!-- POSITION -->
              <v-layout row wrap>
                <v-flex xs12>
                  <v-radio-group v-model="push.position" hint="Position" persistent-hint>
                    <v-radio color="primary" :label="$t('center')" value="center"></v-radio>
                    <v-radio color="primary" :label="$tc('custom', 2, { count: '' })" value="custom"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <!-- POSX POSY -->
              <v-layout row wrap v-show="push.position === 'custom'">
                <v-flex xs12>
                  <v-subheader>Position X sur la page : {{ push.posx }} px (du bord gauche)</v-subheader>
                </v-flex>
                <v-flex xs12 sm5>
                  <v-slider
                    v-model="push.posx"
                    thumb-label
                    min="0"
                    max="2000"
                  ></v-slider>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-show="push.position === 'custom'">
                <v-flex xs12>
                  <v-subheader>Position Y sur la page : {{ push.posy }} px (du bord haut)</v-subheader>
                </v-flex>
                <v-flex xs12 sm5>
                  <v-slider
                    v-model="push.posy"
                    thumb-label
                    min="0"
                    max="2000"
                  ></v-slider>
                </v-flex>
              </v-layout>
            </div>
            <div v-show="push.style == 'picture'">
              <!-- PICTURE -->
              <v-layout row wrap>
                <v-flex xs12 md4>
                  <wz-file-selector @change="saveImg"></wz-file-selector>
                </v-flex>
              </v-layout>
            </div>
            <div v-show="push.style == 'html'">
              <!-- HTML -->
              <v-layout row wrap>
                <!-- Code HTML du push -->
                <v-flex xs12 sm9 md6>
                  <v-text-field
                    textarea
                    class="code-HTML"
                    name="input-1"
                    auto-grow
                    v-model = "push.html"
                    label="Code HTML du push"
                    multi-line
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <!-- TAB 2 -->
      <v-tab-item id='tab-2' key='2'>
        <v-card flat id="tab-2">
          <v-card-text>
            <!-- BEHAVIOUR -->
            <v-layout row wrap>
              <!-- Click-to-Action / comportement -->
              <v-flex xs12>
                <v-select
                  :items="action"
                  v-model="push.action"
                  :label="$t('clickToAction') | cap"
                  small
                  auto
                ></v-select>
              </v-flex>
            </v-layout>
            <!-- URL REDIRECTION -->
            <v-layout row wrap v-show="push.action === 'link'">
              <v-flex xs12 sm5>
                <v-text-field v-model="push.link" label="URL"></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <!-- TAB 3 -->
      <v-tab-item id='tab-3' key='3'>
        <v-card flat id="tab-3">
          <v-card-text>
            <!--
            <v-layout row justify-space-around>
              <v-flex xs1></v-flex>
              <v-flex xs10 sm6>
                <wz-select-one-site></wz-select-one-site>
              </v-flex>
              <v-flex xs1></v-flex>
            </v-layout>
          
            <div v-show="push.style == 'classic'">
              {{ $t('infoPushPreview') }}
            </div>
            -->
            <v-dialog v-model="overlayPreview" >
                <div id="mydesk-push-overlay" @click="hideRenderPush"></div>
            </v-dialog>

            <v-dialog hide-overlay v-model="nonOverlayPreview" >
                <div id="mydesk-push-non-overlay" @click="hideRenderPush"></div>
            </v-dialog>

            <div v-show="classicPreview" id="classic" class="push_Bottom position_bottom_right mydesk-push"></div>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>

    <!-- DIALOGUE HTML -->
    <v-dialog v-model="showDialogCreate">
      <v-card>
        <v-card-title class="primary white--text">Description HTML</v-card-title>
          <v-flex xs4>
            <v-text-field
              name="input-1"
              label="Coller ici vos nouveaux scénarii (XML)"
              textarea
            ></v-text-field>
          </v-flex>
      </v-card>
    </v-dialog>
    <div class="text-xs-right">
      <v-btn color="primary" @click.native="submit"
        fixed
        bottom
        right
        :disabled="alert"
      >
        {{ $t('save') }}
        <v-icon dark right>send</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<style>
/* @import url(../../assets/css/push_bo.css); */
.code-HTML textarea {
  font-family: monospace;
}
</style>

<script>
import _ from 'lodash'
import { DOMAINE, AWSS3_STATIC } from '../../constants'
// Styles
import '../../assets/css/push_bo.css'
export default {
  props: ['id'],
  data () {
    return {
      alert: false,
      /**
       * indique si une requête ajax en cours
       * @type {Boolean}
       */
      loading: false,
       /**
        * affiche/cache la fenetre de dialog de création
        * @type {Boolean}
        */
      showDialogCreate: false,
      /**
      * nouvelle contrainte à créer
      * @type {Object}
      */
      newPushDialog: {name: '', type: '', action: ''},
      // Image Upload
      imgLoading: false,
      overlayPreview: false,
      classicPreview: false,
      nonOverlayPreview: false,
      /**
       * indique si la souris est au-dessus du menu de la liste
       * @type {Boolean}
       */
      overMenu: false,
      /**
       * LE push consulté
       * @type {Array}
       */
      push: { id: '',
        name: '',
        style: 'classic',
        title: '',
        content: '',
        img: '',
        vibra: '',
        vibraFreq: '',
        picture: '',
        link: '',
        licId: '',
        active: '',
        html: '',
        position: '',
        posx: '',
        posy: '',
        action: '',
        overlay: ''
      },
      resAjx: null,
      push_type: [
          { text: this.$t('classic') + ' (pop-up)', value: 'classic' },
          { text: this.$t('picture') + ' (1280 x 720 max)', value: 'picture' },
          { text: 'HTML (code)', value: 'html' }
      ],
      imgpush: [
          { text: this.$t('none'), value: 'blankpix.png' },
          { text: this.$t('woman'), value: 'natasha.png' },
          { text: this.$t('man'), value: 'kevin.png' }
      ],
      action: [
          { text: _.upperFirst(this.$t('doNothing')), value: '' },
          { text: _.upperFirst(this.$t('openURL')), value: 'link' },
          { text: _.upperFirst(this.$t('deployTargetFirst')), value: 'deploy' },
          { text: _.upperFirst(this.$t('show')) + ' Target First ' + this.$t('retractedMode'), value: 'appear_retracted' },
          { text: _.upperFirst(this.$t('show')) + ' Target First ' + this.$t('deployedMode'), value: 'appear_deployed' },
          { text: _.upperFirst(this.$t('show')) + ' click to call', value: 'C2C' }
      ]
    }
  },
  mounted () {
    this.loading = true
    let dataToGet = new window.FormData()
    dataToGet.append('pushId', this.id)
    if (this.$store.state._User.entLevel !== '7' && this.$store.state._User.entOptionPush === 0) {
      this.alert = true
    }
    this.axios.post('get/pushs.php', dataToGet, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
    .then(response => {
      this.resAjx = response.data
      this.loading = false
      this.initPush()
      this.getColor()
    })
    .catch()
  },
  computed: {
    srcData () {
      if (process.env.NODE_ENV === 'development') {
        return `${DOMAINE}/dev/media/push/`
      } else {
        return `${DOMAINE}/media/push/`
      }
    }
  },

  methods: {
    initPush () {
      let _title = this.resAjx.PUSH_TITLE.replace('||||', '')
      let _content = this.resAjx.PUSH_MSG.replace('||||', '')
      if (this.resAjx && this.resAjx !== '') {
        this.push = {
          id: this.resAjx.PUSH_ID,
          name: this.resAjx.PUSH_NAME,
          title: _title,
          content: _content,
          img: this.resAjx.PUSH_IMG,
          vibra: this.resAjx.PUSH_VIBRA_ONOFF,
          vibraFreq: this.resAjx.PUSH_VIBRA_DURATION,
          picture: this.resAjx.PUSH_PICTURE,
          link: this.resAjx.PUSH_LINK,
          licId: this.resAjx.PUSH_LIC_ID,
          active: this.resAjx.PUSH_ONOFF,
          html: this.resAjx.PUSH_HTML,
          position: _.toLower(this.resAjx.PUSH_POSITION),
          posx: this.resAjx.PUSH_POSITION_X,
          posy: this.resAjx.PUSH_POSITION_Y,
          action: this.resAjx.PUSH_ACTION,
          style: this.resAjx.PUSH_STYLE,
          overlay: this.resAjx.PUSH_OVERLAY === '1'
        }
      }
      this.$store.commit('_Toolbar/SET_SUB_TITLE', this.push.name)
    },
    /**
     *  Valide le formulaire et update la BDD et le fichier XML pour le front
     */
    submit () {
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('push', JSON.stringify(this.push))
      this.axios.post('put/push.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
      })
      .catch(_ => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
      })
      .then(_ => {})
    },
    options: {},
    // UPLOADER
    // Méthodes concernant l'upload d'image
    imageuploading (res) {
      if (res.errcode !== 0) {
        this.imgLoading = true
      }
    },
    /**
     * Upload image sur le serveur
     * @return {[type]}     [description]
     */
    saveImg (filename) {
      this.imgLoading = true
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('url', filename)
      dataToPost.append('push_id', this.push.id)
      this.axios.post('put/push_picture.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      // le changement de l'image a été pris en compte
      .then(response => {
        this.push.picture = response.data
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
      })
      .catch(e => {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
        console.log(e)
      })
      .then(_ => {
        this.imgLoading = false
      })
    },
    renderPush () {
      if (this.push.style !== 'classic') {
        if (this.push.overlay) {
          this.overlayPreview = true
          this.nonOverlayPreview = false
        } else {
          this.overlayPreview = false
          this.nonOverlayPreview = true
        }
      }
      if (this.push.style === 'classic') {
        let classicPush = ''
        /* classicPush += '<div id="mydesk-push" class="push_Right mydesk-push">'
        classicPush += '  <div id="closePush" class="ui-icones hidePush"></div>'
        classicPush += '  <div id="mydesk-push-photo" class="mydesk-push-photo-right" style="display:block"><img id="photoHotesse" src="../../img/hotesses/' + this.push.img + '"></div>'
        classicPush += '  <div class="mydesk-text-push">'
        classicPush += '    <p class="mydesk-title-push">' + this.push.title + '</p>'
        classicPush += '    <p class="mydesk-content-push">' + this.push.content + '</p>'
        classicPush += '  </div>'
        classicPush += '</div>' */
        classicPush += '<div id="mydesk-push" class="push_Right mydesk-push">'
        classicPush += '<div id="closePush" class="hidePush"></div>'
        classicPush += '<div id="standard_push">'
        classicPush += '<div id="mydesk-push-photo" class="mydesk-push-photo-right">'
        classicPush += '<img id="agent_photo" src="' + AWSS3_STATIC + '/img/hotesses/' + this.push.img + '"'
        classicPush += '>'
        classicPush += '</div>'
        classicPush += '<div class="mydesk-text-push"><p class="mydesk-title-push" id="mydesk-title-push" >'
        classicPush += this.push.title
        classicPush += '</p>'
        classicPush += '<p class="mydesk-content-push" id="mydesk-content-push" >'
        classicPush += this.push.content
        classicPush += '</p></div></div></div>'
        document.getElementById('classic').innerHTML = classicPush
        this.classicPreview = true
        this.getColor()
      } else {
        this.classicPreview = false
        let content = ''
        if (this.push.style === 'html') {
          if (this.push.position === 'center') {
            content = '<div id="pushPicture" ><div class="pushclose" id="pushclose" title="Close" ><svg version="1.1" id="removeImg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 30" enable-background="new 0 0 30 30" xml:space="preserve"><title></title><polygon fill="#FFFFFF" points="28.3,2.4 27.6,1.7 15,14.3 2.4,1.7 1.7,2.4 14.3,15 1.7,27.6 2.4,28.3 15,15.7 27.6,28.3 28.3,27.6 15.7,15 "></polygon></svg></div><div id="custom_push_content">' + this.push.html + '</div></div>'
          } else {
            content = '<div id="pushPicture" style="top:' + this.push.posy + 'px;left:' + this.push.posx + 'px" ><div class="pushclose" id="pushclose" title="Close" ><svg version="1.1" id="removeImg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 30" enable-background="new 0 0 30 30" xml:space="preserve"><title></title><polygon fill="#000000" points="28.3,2.4 27.6,1.7 15,14.3 2.4,1.7 1.7,2.4 14.3,15 1.7,27.6 2.4,28.3 15,15.7 27.6,28.3 28.3,27.6 15.7,15 "></polygon></svg></div><div id="custom_push_content">' + this.push.html + '</div></div>'
          }
        }
        // push image
        if (this.push.style === 'picture') {
          if (this.push.position === 'center') {
            content = '<div id="pushPicture"  ><div class="pushclose" id="pushclose" title="Close" ><svg version="1.1" id="removeImg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 30" enable-background="new 0 0 30 30" xml:space="preserve"><title></title><polygon fill="#000000" points="28.3,2.4 27.6,1.7 15,14.3 2.4,1.7 1.7,2.4 14.3,15 1.7,27.6 2.4,28.3 15,15.7 27.6,28.3 28.3,27.6 15.7,15 "></polygon></svg></div><img class="pushCenterImage" src="' + this.srcData + this.push.picture + '?' + Math.random() + '" ></div>'
          } else {
            content = '<div id="pushPicture" style="top:' + this.push.posy + 'px;left:' + this.push.posx + 'px" ><div class="pushclose" id="pushclose" title="Close" ><svg version="1.1" id="removeImg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 30" enable-background="new 0 0 30 30" xml:space="preserve"><title></title><polygon fill="#FFFFFF" points="28.3,2.4 27.6,1.7 15,14.3 2.4,1.7 1.7,2.4 14.3,15 1.7,27.6 2.4,28.3 15,15.7 27.6,28.3 28.3,27.6 15.7,15 "></polygon></svg></div><img src="' + this.srcData + this.push.picture + '?' + Math.random() + '" ></div>'
          }
        }
        if (this.push.overlay) {
          document.getElementById('mydesk-push-non-overlay').innerHTML = ''
          document.getElementById('mydesk-push-overlay').innerHTML = content
        } else {
          document.getElementById('mydesk-push-overlay').innerHTML = ''
          document.getElementById('mydesk-push-non-overlay').innerHTML = content
        }
      }
    },
    hideRenderPush () {
      this.overlayPreview = false
      this.nonOverlayPreview = false
      this.classicPreview = false
    },
    getColor () {
      this.axios.get('get/settings_preview.php?desk=' + this.$store.state._Sites.siteSelected.LIC_DSK_ID)
      .then(res => {
        this.options.DSK_COLORS = res.data.DSK_COLORS.split('|')
        if (document.getElementById('mydesk-title-push')) {
          document.getElementById('mydesk-title-push').style.color = '#' + this.options.DSK_COLORS[5]
        }
        if (document.getElementById('mydesk-content-push')) {
          document.getElementById('mydesk-content-push').style.color = '#' + this.options.DSK_COLORS[5]
        }
        if (document.getElementById('mydesk-title-push')) {
          document.getElementById('mydesk-title-push').style.background = '#' + this.options.DSK_COLORS[0]
          // console.log(this.options.DSK_COLORS[0])
        }
        if (document.getElementById('mydesk-push')) {
          document.getElementById('mydesk-push').style.background = '#' + this.options.DSK_COLORS[1]
          document.getElementById('closePush').style.backgroundColor = '#' + this.options.DSK_COLORS[1]
          // console.log(this.options.DSK_COLORS[1])
        }
      })
    }
  },
  watch: {
    '$store.state._Sites.siteSelected': function () {
      this.getColor()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/media/Push.vue